namespace appn.views.users.index {

    class InitArgs {
        dtColCount: number = 0;
        userTypes: Array<SelectListItem> = [];
        userStatuses: Array<SelectListItem> = [];
        userPermissionManageUsers: boolean = false;
        exportUserRows: string = emptyString;
        usersCreate: string = emptyString;
        usersIndex: string = emptyString;
        userId: number = 0;
        canSeeCheckboxes: boolean = false;
        providerType: string = emptyString;
        usersAjaxUserDeleteInformation: string = emptyString;
        showGroup: string = emptyString;
    }

    let _initArgs: InitArgs;
    let _selectedItems;
    let _dataTable: any = null;
    let _cycle: number = 0;

    export function init(args: InitArgs): void {
        _initArgs = args;

        appn.userGroupFilter.init(_initArgs.usersIndex);

        createDataTable();
        addEvents();

        if (utils.hasValue(_initArgs.showGroup)) {
            const link = $(`a.appnUserGroupFilter-link i[data-modal-iframe*="${_initArgs.showGroup}"]`);

            if (link)
                link.trigger('click');
        }
            
    }

    function addEvents() {
        // hook up checkboxes for mass delete
        $(document).on('change', '.appnGlobalConfirmDelete input[id^="user_"]', function() {
            const userIdsToMassDelete: Array<string> = [];
            $('.appnGlobalConfirmDelete input[id^="user_"]').each(function(index: number, checkBox: HTMLElement) {
                const isChecked = $(checkBox).prop('checked');
                if (isChecked) {
                    const id = ($(checkBox).attr('id') as string).split('_')[1];
                    userIdsToMassDelete.push(id);
                }
            });

            $('#usersToMassDelete').val(userIdsToMassDelete.join(','));
        });

        $(document).on('click', '.dataTables_scrollHeadInner th.sorting:first', function () {
            // Check if the style tag already exists
            let styleTag = $("#dynamic-style");

            if (styleTag.length === 0) {
                // Create a new <style> tag if it doesn't exist
                styleTag = $('<style>')
                    .prop('id', 'dynamic-style')
                    .prop('type', 'text/css')
                    .appendTo("head");
            }

            // Increment or reset once all 4 states have been cycled
            if (_cycle === 3)
                _cycle = 0;
            else
                _cycle++;

            // Decide on the color
            let colorVar = _cycle > 1 ? '--datatable-sort-color-alt' : '--datatable-sort-color-default';

            $('html').css('--datatable-sort-color', `var(${colorVar})`);

            styleTag.html(`
                table.dataTable thead > tr > th.sorting_asc::after,
                table.dataTable thead > tr > th.sorting_desc::after {
                    color: var(--datatable-sort-color) !important;
                }
            `);
            
            $('#sCustom_3').val(_cycle);
        });

        $(document).on('click', '.dataTables_scrollHeadInner th.sorting:nth-child(n+3)', function () {
            $("#dynamic-style").remove();
            _cycle = 0;
            $('#sCustom_3').val(_cycle);
        });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sDom: appn.dataTable.genSDom(1, 0, 3),
            sAjaxSource: 'Users/DataTable',
            fnServerData: function(data: any): any {
                data.push(
                    { name: 'sCustom_0', value: appn.userGroupFilter.getStateOrDefault().value },
                    appn.dataTable.getStateOrDefault('sCustom_1', $('#sCustom_1').val()),
                    appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()),
                    appn.dataTable.getStateOrDefault('sCustom_3', $('#sCustom_3').val()));
            },
            autoWidth: false,
            scrollX: '100%',
            aaSorting: [[1, 'asc']],
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '27%' },
                { bSortable: true, sWidth: '27%' },
                { bSortable: true, sWidth: '15%' },
                { bSortable: true, sWidth: '10%' },
                { bSortable: true, sWidth: '15%' }
            ],
            fnInitComplete: function(): any {
                $('.dataTables_filter').prepend(elementBuilder.buildSelect(_initArgs.userTypes, 'sCustom_2', 'saveMeState', 'ALL TYPES'));
                $('.dataTables_filter').prepend(elementBuilder.buildSelect(_initArgs.userStatuses, 'sCustom_1', 'saveMeState'));

                // Check if we start on descending or ascending sort
                const head = $('.dataTables_scrollHeadInner th.sorting:first');

                _cycle = 0;
                if (head.attr('aria-sort') === 'descending')
                    _cycle = 1;
                    
                $('#sCustom_3').val(_cycle);
                $('.dataTables_filter').prepend(elementBuilder.createElement('input', 'saveMeState', 'sCustom_3', [['type', 'hidden'], ['value', $('#sCustom_3').val() as string]]));

                // Inject Screen Action buttons
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                ], appn.requestUser.isUserOrHigher && _initArgs.userPermissionManageUsers, true);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'addnew', buttonType: 'AddNew' }
                ], appn.requestUser.isUserOrHigher && _initArgs.userPermissionManageUsers);

                // Prepends the show button
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                $('#addnew').click(function(e): void {
                    e.preventDefault();
                    appn.location.navTo(_initArgs.usersCreate, [
                        {
                            name: 'groupId',
                            value: appn.userGroupFilter.selectedGroupId
                        }
                    ]);
                });

                $('#importusers').click(function(e) {
                    e.preventDefault();
                    ($('#importDialog') as any).modal('show');
                    return false;
                });

                $('#usersImportForm').submit(function(e): void {
                    e.preventDefault();
                    appn.hasFormSubmitAlreadyHappened = false;
                    appn.ajax.post({
                        url: $('#usersImportForm').attr('action') as string,
                        data: new FormData(this as HTMLFormElement),
                        contentType: false, // Needed when uploading a file
                        processData: false, // Needed when uploading a file
                        done: function() {
                            appn.ui.showImportConfirmation('Users');
                            appn.notifications.updateNotificationTotal();
                        },
                        fail: function(jqXHR: JQueryXHR, textStatus: string, errorThrown: any) {
                            appn.toast.notify(toast.Type.error, T('User import failed.'));
                        },
                        always: function() {
                            appn.dialog.hide();
                            appn.dialog.hideLoading();
                        }
                    });
                });

                $('#exportUsers').off().on('click', function(event) {
                    event.preventDefault();
                    $('#dialog-exportUsers').modal('show');
                });

                $('#exportUsersDialogButton').off().on('click', function(event) {
                    event.preventDefault();

                    appn.ajax.get({
                        url: _initArgs.exportUserRows,
                        data: {
                            isProtectData: $('#ExportSettings_AnonymizePersonalData').is(':checked'),
                            includeUserAudits: $('#ExportSettings_IncludeUserAudits').is(':checked')
                    },
                    done: function() {
                        (parent as any).appn.notifications.updateNotificationTotal();
                        $('#dialog-exportUsers').modal('hide');
                        ui.showExportConfirmation('Users');
                    }
                    });
                });

                // Bind manage users button
                $('#manageBtn').click(function(e): void {
                    e.preventDefault();

                    appn.dialog.showContentSpinner($('#manageUsersDialog'));

                    if (!$(this).prop('disabled')) {
                        // Set selectedItems
                        _selectedItems = $('.selectRow:checked');

                        let userIds = appn.emptyString;
                        $(_selectedItems).map(function(): void {
                            userIds += $(this).attr('id') + ',';
                        });

                        $('#usersToManage').val(userIds);
                        ($('#manageUsersDialog') as any).modal('show');

                        const submitButton = $('#manageUsersDialog .card-header button[value="Delete"].btn-tool-danger');
                        createDeleteMessageFromTable(submitButton, _selectedItems);
                    }
                });

                appn.dataTable.addSearchPlaceholder(T(`Filter results where the User's <b>Email, First Name, Last Name, External Id or Status</b> contains a keyword entered here.`));

                appn.saveMeState.init(function(): any {
                    _dataTable.fnDraw(false);
                },
                    function(): any {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');

            }
        });
    }

    function createDeleteMessageFromTable(button: JQuery<HTMLElement>, selectedRows: any) {
        button.attr('data-deletedetail', emptyString);
        button.attr('data-deletemessage', emptyString);
        let loginIds: Array<string> = [];
        const usersList: Array<UserDetailResult> = [];
        
        if (selectedRows.length > 1) { // If we have multiple items
            selectedRows.each(function(index: number, selected: JQuery<HTMLElement>) {
                usersList.push({
                    Id: Number($(selected).attr('id')),
                    FullName: undefined,
                    LoginId: $($(selected).closest('tr').find('td')[2]).text(),
                    Email: undefined,
                    Count: undefined,
                    FirstName: undefined,
                    LastName: undefined,
                    Status: undefined,
                    HasWebAccess: undefined,
                    Level: undefined,
                    Type: undefined,
                    ProviderId: requestProvider.id
                });
            });

            loginIds = usersList.map(u => u.LoginId);
        } else { // if we have a single item
            usersList.push({
                Id: Number($(selectedRows[0]).attr('id')),
                FullName: undefined,
                LoginId: $($(selectedRows[0]).closest('tr').find('td')[2]).text(),
                Email: undefined,
                Count: undefined,
                FirstName: undefined,
                LastName: undefined,
                Status: undefined,
                HasWebAccess: undefined,
                Level: undefined,
                Type: undefined,
                ProviderId: requestProvider.id
            });
            
            loginIds = usersList.map(u => u.LoginId);
        }

        appn.ajax.post({
            url: _initArgs.usersAjaxUserDeleteInformation,
            dataType: 'json',
            data: { userLoginIds: loginIds, requestingProviderId: requestProvider.id },
            done: function(userDetailLists: Array<Array<UserDetailResult>>) {
                const userDetailsList: Array<UserDetailResult> = [];

                // Take the highest level user with this email address
                userDetailLists.forEach(function(userDetailList: Array<UserDetailResult>, index: number, original: Array<Array<UserDetailResult>>) {
                    const topUser = userDetailList.filter((o, i, a) => {
                        return o.ProviderId === requestProvider.id;
                    })[0];
                    userDetailsList.push({
                        Id: topUser.Id,
                        FullName: `${topUser.LastName}, ${topUser.FirstName}`,
                        LoginId: topUser.LoginId,
                        Email: topUser.Email,
                        Count: userDetailList.length,
                        FirstName: topUser.FirstName,
                        LastName: topUser.LastName,
                        Status: topUser.Status,
                        HasWebAccess: topUser.HasWebAccess,
                        Level: topUser.Level,
                        Type: topUser.Type,
                        ProviderId: requestProvider.id
                    });
                });

                if (!utils.hasValue(userDetailsList)) {
                    button.attr('disabled', 'disabled');
                    return;
                }

                button.removeAttr('disabled');
                let msg: string;
                let removeAllMessage = emptyString;
                let userStat = emptyString;

                const ul = elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));

                if (userDetailsList.length > 1) {
                    userDetailsList.forEach(function(user: UserDetailResult, index: number, original: Array<UserDetailResult>) {
                        removeAllMessage = emptyString;

                        if (user.Count! > 1 && _initArgs.canSeeCheckboxes) {
                            const hint = buildHint(user.Level);
                            const text = _initArgs.providerType === 'Vendor' ? 'Remove user from all associated clients' : _initArgs.providerType === 'Enterprise' ? 'Remove user from all associated environments' : emptyString;
                            userStat = _initArgs.providerType === 'Vendor' ? '(<b>{0}</b> associated clients)' : _initArgs.providerType === 'Enterprise' ? '(<b>{0}</b> associated environments)' : emptyString;

                            if (hint.hasValue() && text.hasValue())
                                removeAllMessage = elementBuilder.buildCheckboxWithHint(text, hint, undefined, `user_${user.Id}`, undefined, `user_${user.Id}`, undefined);
                        }

                        const li = elementBuilder.createElement('li', undefined, undefined, undefined,
                            `<p><b>${user.FullName}</b>${userStat.hasValue() ? ' ' + T(userStat, user.Count) : emptyString}</p>${removeAllMessage.hasValue() ? removeAllMessage : emptyString}`);
                        ul.appendChild(li);
                    });

                    msg = T('The following <b>Users</b> and all their associated data will be permanently deleted.') + ul.outerHTML;
                } else {
                    const user = userDetailsList[0];
                    if (user.Count! > 1 && _initArgs.canSeeCheckboxes) {
                        const hint = buildHint(user.Level);
                        const text = _initArgs.providerType === 'Vendor' ? 'Remove user from all associated clients' : _initArgs.providerType === 'Enterprise' ? 'Remove user from all associated environments' : emptyString;
                        userStat = _initArgs.providerType === 'Vendor' ? '(<b>{0}</b> associated clients)' : _initArgs.providerType === 'Enterprise' ? '(<b>{0}</b> associated environments)' : emptyString;

                        if (hint.hasValue() && text.hasValue())
                            removeAllMessage = elementBuilder.buildCheckboxWithHint(text, hint, undefined, `user_${user.Id}`, undefined, `user_${user.Id}`, undefined);
                    }

                    msg = `<p><b>${user.FullName}</b>${userStat.hasValue() ? ' ' + T(userStat, user.Count) : emptyString}` + T(' and all their associated data will be permanently deleted.') + `</p>${removeAllMessage.hasValue() ? removeAllMessage : emptyString}`;
                }

                const p = elementBuilder.createElement('p', undefined, undefined, undefined, msg);
                const msgWarning = T('The selected item(s) will be <b>permanently deleted</b> with <b>no option</b> to recover this data.');
                const p2 = elementBuilder.createElement('p', 'mt-4', undefined, undefined, msgWarning);

                button.attr('data-deletedetail', JSON.stringify(p.outerHTML));
                button.attr('data-deletemessage', p2.outerHTML);
            },
            always: function() {
                appn.dialog.removeContentSpinner($('#manageUsersDialog'));
            }
        });
    }

    function buildHint(level: AccessLevel | undefined): string {
        const clientHint = T('This user is has {0} access and the organization is a client of a Vendor. Check the box to remove this user from all client accounts linked with this Vendor. If you continue without removing this user from all other clients, you may incur additional user license fees.', level === AccessLevel.VendorAdmin ? 'Vendor Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : emptyString);
        const enviroHint = T('This user is has {0} access and the organization is part of an Enterprise Toolkit. Check the box to remove this user from all environments. If you continue without removing this user from all other environments, you may incur additional user license fees.', level === AccessLevel.EnterpriseAdmin ? 'Enterprise Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : emptyString);

        return _initArgs.providerType === 'Vendor' ? clientHint : _initArgs.providerType === 'Enterprise' ? enviroHint : emptyString;
    }

    interface UserInfo {
        FullName: string | undefined;
        Count: number | undefined;
    }

    interface UserDetailResult extends UserInfo {
        Id: number | undefined;
        LastName: string | undefined;
        FirstName: string | undefined;
        LoginId: string;
        Email: string | undefined;
        Status: UserStatus | undefined;
        Type: UserType | undefined;
        HasWebAccess: boolean | undefined;
        Level: AccessLevel | undefined;
        ProviderId: number;
    }

    enum AccessLevel {
        ReadOnly = 10,
        User = 20,
        Admin = 30,
        EnterpriseAdmin = 40,
        VendorAdmin = 50,
        SuperAdmin = 99
    }
}
